import React, { useState, useEffect } from "react";
import Aravinth from "./photos/picture2.png";

const About = () => {
  const [columns, setColumns] = useState(12);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const setWindowDimensions = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  useEffect(() => {
    if (windowWidth <= 420) {
      setColumns(5);
    } else if (windowWidth <= 700) {
      setColumns(7);
    } else if (windowWidth <= 1024) {
      setColumns(10);
    } else {
      setColumns(12);
    }
  }, [windowWidth]);

  return (
    <div className="mt-10 md:mt-16 leading-8 md:leading-10 min-h-screen">
      <h1 className="text-3xl md:text-4xl text-center font font-semibold mb-6">
        About Us
      </h1>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 p-8 rounded-2xl shadow-2xl max-w-4xl mx-auto bg-gradient-to-r from-gray-900 to-gray-800 transition-transform duration-300 hover:scale-105">
          <img
            src={Aravinth}
            alt="Aravinth R"
            className="w-72 h-72 md:w-96 md:h-96 rounded-full border-4 border-gray-400 shadow-[0_0_40px_rgba(59,130,246,0.6)] object-cover transition-transform duration-500 hover:scale-110 hover:shadow-[0_0_60px_rgba(99,102,241,0.8)]"
          />
          <div className="text-center md:text-left">
            <h2 className="text-3xl font-extrabold text-white mb-3 drop-shadow-lg tracking-wide">
              Aravinth R
            </h2>
            <p className="text-xl text-gray-300 mb-2 font-medium">
              BE-CSE [2022 - 2026]
            </p>
            <p className="text-xl text-gray-300 mb-4 font-medium">
              Full Stack Developer
            </p>
            <a
              href="https://aravinthr.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-2 text-blue-400 hover:text-blue-300 transition-colors duration-200 text-xl"
            >
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcLETjv1QaPw4tRyAh0VzepIX_tBmses9KBg&s"
                alt="Website Icon"
                className="w-7 h-7"
              />
              About Me
            </a>
            <br />
            <a
              href="https://www.instagram.com/aravinth_lone"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-3 text-pink-500 hover:text-pink-400 transition-colors duration-200 text-xl"
            >
              <img
                src="https://img.icons8.com/fluency/48/instagram-new.png"
                alt="Instagram Icon"
                className="w-7 h-7"
              />
              Instagram
            </a>
            <br />
            <a
             href="https://www.linkedin.com/in/aravinth-r-b52b84244/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-3 text-blue-400 hover:text-blue-300 transition-colors duration-200 text-xl"
            >
              <img
                src="https://img.icons8.com/color/48/000000/linkedin.png"
                alt="LinkedIn Icon"
                className="w-7 h-7"
              />
              LinkedIn
            </a>
          </div>
        </div>

      <main className="p-3 md:flex justify-center items-center flex-col md:mt-8">
        <section className="text-[18px] md:text-2xl">
          A Multi-purpose website created for SCT Students, which includes:
          <ul className="list-disc ml-9">
            <li>
              <span className="underline underline-offset-4 decoration-sky-500">
                GPA
              </span>{" "}
              Calculator,
            </li>
            <li>
              <span className="underline underline-offset-4 decoration-sky-500">
                CGPA
              </span>{" "}
              Calculator,
            </li>
            <li>
              It also has all the{" "}
              <span className="underline underline-offset-4 decoration-sky-500">
                Hall Location, Lab Details
              </span>
              ,
            </li>
            <li>
              It also includes the{" "}
              <span className="underline underline-offset-4 decoration-sky-500">
                Exam Schedules (CIE, Semester), Academic Calendar, and the{" "}
                <span className="underline underline-offset-4 decoration-sky-500">
                  Previous Year Question Papers
                </span>
                .
              </span>
            </li>
            <li>
              It also includes the syllabus for all{" "}
              <span className="underline underline-offset-4 decoration-sky-500">
                8 Semesters across all Departments.
              </span>
            </li>
          </ul>
        </section>
      </main>

      <div className="p-3 md:flex justify-center items-center flex-col md:mt-8">
        <section className="text-[18px] md:text-2xl">
          <p>
            For any doubts or clarifications, feel free to contact us at{" "}
            <a
              href="mailto:reportssonacgpa@gmail.com"
              className="text-blue-400 underline font-semibold hover:text-blue-900 transition-colors"
            >
              ✉️ reportssonacgpa@gmail.com
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
};

export default About;
